import { IGameLeadInput } from '@/interface/gameLead';
import { AppDispatch } from '@/redux';
import { GET_GAME_GQL, GET_GAME_META_TAGS_GQL } from '@/redux/query/game';
import {
  setGame,
  setGameError,
  setIsGameGetPending,
} from '@/redux/reducer/game';
import { apolloClient } from '@/service/apolloClient';
import { localStorage_ } from '@/util';
import { getNetworkError } from '@/util/network';
import { replaceCDNToS3Url } from '@/util/url';

export const getGameActionSSR = (id: string) => {
  const query = GET_GAME_GQL;
  return new Promise(resolve => {
    apolloClient
      .query({
        query,
        variables: { id: id },
        fetchPolicy: 'no-cache',
      })
      .then(({ data }) => {
        const { getGame: res } = data;
        if (res) {
          resolve({ data: res });
        }
      })
      .catch(err => {
        const error = getNetworkError(err);
        resolve({ error }); // Reject the Promise if there's an error
      });
  });
};

export const getGameMetaTagsActionSSR = (id: string) => {
  const query = GET_GAME_META_TAGS_GQL;
  return new Promise(resolve => {
    apolloClient
      .query({
        query,
        variables: { id: id },
        fetchPolicy: 'no-cache',
      })
      .then(({ data }) => {
        const { getGameMetaTags: res } = data;
        if (res) {
          resolve({ data: res });
        }
      })
      .catch(err => {
        const error = getNetworkError(err);
        resolve({ error }); // Reject the Promise if there's an error
      });
  });
};

export const getGameAction = (id: string) => {
  const query = GET_GAME_GQL;
  return (dispatch: AppDispatch) => {
    dispatch(setIsGameGetPending(true));
    apolloClient
      .query({
        query,
        variables: { id: id },
        fetchPolicy: 'no-cache',
      })
      .then(({ data }) => {
        const { getGame: res } = data;
        if (res) {
          let elements = res?.config?.elements || [];
          elements = elements.map((ele: any) => {
            return {
              ...ele,
              uri: replaceCDNToS3Url(ele?.uri || ''),
            };
          });
          res.config = {
            ...res.config,
            elements,
          };
          dispatch(setGame(res));
        }
      })
      .catch(err => {
        const error = getNetworkError(err);
        dispatch(setGameError(error));
      })
      .finally(() => {
        dispatch(setIsGameGetPending(false));
      });
  };
};

export const saveGameUserInfoLSAction = async (
  gameId: string,
  userInfo?: IGameLeadInput
) => {
  try {
    const data = JSON.stringify(userInfo);
    await localStorage.setItem(`@game_info_${gameId}`, data);
    // eslint-disable-next-line no-empty
  } catch {}
};

export const getGameUserInfoLSAction = async (gameId: string) => {
  return await localStorage_.getItem(`@game_info_${gameId}`);
};

export const isStoredUserInfoLSAction = async (gameId: string) => {
  try {
    const data = await localStorage.getItem(`@game_info_${gameId}`);
    if (!data) {
      return false;
    }
    return true;
    // eslint-disable-next-line no-empty
  } catch {
    return false;
  }
};
